module.exports = __webpack_public_path__ + "media/src/public/img/payment/alfabank-logo-min-7754bac80ab63385834a571b7343d6ae.svg";